import { render, staticRenderFns } from "./admin-monitor.vue?vue&type=template&id=acdd0c8e&scoped=true&"
import script from "./admin-monitor.vue?vue&type=script&lang=js&"
export * from "./admin-monitor.vue?vue&type=script&lang=js&"
import style0 from "./admin-monitor.vue?vue&type=style&index=0&id=acdd0c8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acdd0c8e",
  null
  
)

export default component.exports